import {
  ISSUE_FINISHED, ISSUES_FINISHED, ISSUE_REOPENED,
  ISSUES_LIST_REFRESH, ISSUES_FORGET_FINISHED,
  ROW_SETTLED, ROWS_SETTLED, ROW_UNSETTLED, ROWS_SETTLE_SWEEP,
} from "../constants/action-types/issues";

/** An issue reached a terminal status (resolved / abandoned / rejected):
 *  every list drops it now rather than at the next reload. */
export const issueFinished = (issueId, status = "resolved") => ({
  type: ISSUE_FINISHED,
  payload: { id: String(issueId), status },
});

/** The bulk version - one action for a whole ticked selection. */
export const issuesFinished = (issueIds = [], status = "resolved") => ({
  type: ISSUES_FINISHED,
  payload: { ids: (issueIds || []).map(String), status },
});

/** Put an issue back on the lists (reopened, or a terminal status that
 *  turned out to be a review request rather than an ending). */
export const issueReopened = (issueId) => ({
  type: ISSUE_REOPENED,
  payload: { id: String(issueId) },
});

/** The refresh icon: bump a counter every list watches, so each one
 *  refetches without the browser reloading the page. */
export const refreshIssueLists = () => ({ type: ISSUES_LIST_REFRESH });

/** Forget what was finished in this session. A refetch already leaves
 *  those rows out, so keeping the ids only risks hiding an issue that
 *  was reopened elsewhere. */
export const forgetFinishedIssues = () => ({ type: ISSUES_FORGET_FINISHED });

// ── a decided row ────────────────────────────────────────────────────────
//
// `scope` names the list ("proposals", "revisions", "imports", "schedule",
// "checklist", "triage", "issues") so the same id in two lists cannot
// collide. `label` is what the row shows: "Approved", "Sent back",
// "Resolved", "Abandoned", "Applied", "Removed", "Accepted".
export const rowSettled = (scope, id, label = "Done") => ({
  type: ROW_SETTLED, payload: { scope, id: String(id), label, at: Date.now() },
});
export const rowsSettled = (scope, ids = [], label = "Done") => ({
  type: ROWS_SETTLED, payload: { scope, ids: (ids || []).map(String), label, at: Date.now() },
});
export const rowUnsettled = (scope, id) => ({ type: ROW_UNSETTLED, payload: { scope, id: String(id) } });
export const sweepSettledRows = (before) => ({ type: ROWS_SETTLE_SWEEP, payload: { before } });
